module.exports = __webpack_public_path__ + "img/hotspot-alt.d06ca178.svg";